import { render } from "./GridERP_Parametri.vue?vue&type=template&id=62444a49&scoped=true&ts=true"
import script from "./GridERP_Parametri.vue?vue&type=script&lang=ts"
export * from "./GridERP_Parametri.vue?vue&type=script&lang=ts"

import "./GridERP_Parametri.vue?vue&type=style&index=0&id=62444a49&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62444a49"]])

export default __exports__